"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../utils/helpers");
var immutable_1 = require("immutable");
var _initial = immutable_1.Map();
/**
 * The main idea behind Cache is ability to keep
 * latest request state, which lead to current response
 * We may use this in Agent for validating, whether we need to run a request,
 * whether the request state has changed and how did it change
 */
var Cache = /** @class */ (function () {
    function Cache(resolver) {
        this.cache = _initial;
        this.resolve = helpers_1.debounce(this.invalidate);
        this.resolver = resolver;
        this.invalidate = this.invalidate.bind(this);
    }
    /**
     * Forces re-caching and clears the cache
     */
    Cache.prototype.invalidate = function () {
        this.resolver(this.cache);
        this.purge();
    };
    /**
     * Used to cache new request parameter
     * @param field field to cache
     * @param value value to cache
     */
    Cache.prototype.set = function (field, value) {
        this.cache = this.cache.set(field, value);
        this.resolve();
    };
    /**
     * Resets cache field to initial value, and then forces re-caching
     * If no field is provided, resets the cache to pre-initialized empty immutable.Map()
     * @param field field to reset
     */
    Cache.prototype.reset = function (field) {
        if (!field) {
            this.cache = _initial;
        }
        else {
            this.cache = this.cache.delete(field);
        }
        this.resolve();
    };
    Cache.prototype.purge = function () {
        this.cache = _initial;
    };
    return Cache;
}());
exports.Cache = Cache;
//# sourceMappingURL=Cache.js.map